import styled from 'styled-components';

import ZIndexLayers from '../../services/ZIndexLayers';
import { BottomSheetContainer, DropDownMenu } from '../Dropdown/Dropdown.styles';

interface DropDownMenuProps {
  width?: number;
  $maxHeight?: string;
}

export const StyledDropDownMenu = styled(DropDownMenu)<DropDownMenuProps>`
  max-height: ${(props: DropDownMenuProps) => props.$maxHeight || 'auto'} !important;
  width: 25rem;
  z-index: ${ZIndexLayers.overModal};
`;

export const StyledBottomSheetContainer = styled(BottomSheetContainer)<DropDownMenuProps>`
  max-height: ${(props: DropDownMenuProps) => props.$maxHeight || 'auto'} !important;
  overflow-y: auto;
`;

export const ShimmerItemContainer = styled.div`
  display: flex;
  width: 100%;
  height: 2.75rem;
  padding: 0.75rem;
  justify-content: space-between;
`;
